import debug from './Utils/Debug';
import Environment from './Utils/Env';
import Feature from './Utils/Feature';

const Env = new Environment();

/* aliases */
const env = Env;

export {
    debug,
    Env,
    Feature,
    /* aliases */
    env
};
